import type { RushMidSnapshot } from '@cs-shot/battle-sim';

export interface SnapshotOrderView {
  status: RushMidSnapshot['status'];
  round?: number;
  stateVersion?: number;
  matchId?: string;
}

const STATUS_RANK: Record<RushMidSnapshot['status'], number> = {
  NONE: 0, PARTY: 1, OPEN: 2, BUYING: 3, PLAYING: 4, OVER: 5,
};

const roundOf = (s: SnapshotOrderView): number =>
  (s.status === 'PLAYING' || s.status === 'OVER') && s.round !== undefined ? s.round : -1;

const versionNotOlder = (next: SnapshotOrderView, prev: SnapshotOrderView): boolean =>
  next.stateVersion === undefined || prev.stateVersion === undefined
    ? true
    : next.stateVersion >= prev.stateVersion;

export const isNewerSnapshot = (next: SnapshotOrderView, prev: SnapshotOrderView | null): boolean => {
  if (!prev) return true;
  if (next.status === 'NONE') return true;
  if (prev.status === 'OVER') return next.matchId !== undefined && next.matchId !== prev.matchId;
  if (next.status === 'PARTY' && prev.status === 'OPEN') return true;
  if (next.matchId !== undefined && prev.matchId !== undefined && next.matchId !== prev.matchId) return true;
  const ra = STATUS_RANK[next.status];
  const rb = STATUS_RANK[prev.status];
  if (ra !== rb) return ra > rb;
  if (next.status === 'PLAYING' && roundOf(next) !== roundOf(prev)) {
    return roundOf(next) > roundOf(prev);
  }
  return versionNotOlder(next, prev);
};
